module.exports = __webpack_public_path__ + "img/img-11.20b648a3.jpg";